import type { IModalsStore } from '~/modules/main'

export const state = (): IModalsStore => {
  return {
    prize: {
      isOpened: false,
      data: null,
      hideRoulette: false,
    },
    promo: {
      isOpened: false,
    },
    languageSwitcher: {
      isOpened: false,
    },
    dailyReward: {
      isOpened: false,
      received: false,
      data: null,
    },
    ratingPrevious: {
      isOpened: false,
      data: null,
    },
    ratingResults: {
      isOpened: false,
      hasAutoShown: false,
    },
    onboarding: {
      isOpened: false,
      hasAutoShown: false,
    },
  }
}
